import { computed, ref } from 'vue';
import { get, last, uniqueId } from 'lodash-es';

type ErrorMessageListType = Array<{
  id: string;
  text: string;
}>;

const DEFAULT_TOAST_DISPLAY_TIME = 5000;

export function useErrorToast() {
  const isErrorVisible = ref(false);
  const errorMessagesList = ref<ErrorMessageListType>([]);
  const errorMessage = computed(
    () => last(errorMessagesList.value)?.text ?? '',
  );
  let timeout: ReturnType<typeof setTimeout>;

  type ShowErrorProps = { time?: number; text?: string };

  function showError(props?: ShowErrorProps) {
    errorMessagesList.value.pop();
    errorMessagesList.value.push({
      id: uniqueId('_search-form-error-toast'),
      text: get(props, 'text', ''),
    });

    isErrorVisible.value = true;

    timeout = setTimeout(() => {
      hideError();
    }, get(props, 'time', DEFAULT_TOAST_DISPLAY_TIME));
  }

  function hideError() {
    clearTimeout(timeout);
    errorMessagesList.value = [];
    isErrorVisible.value = false;
  }

  function validate(condition: boolean, text = ''): Promise<void> {
    hideError();
    return new Promise((resolve, reject) => {
      if (condition) {
        resolve();
      } else {
        showError({
          text,
        });

        reject();
      }
    });
  }

  return {
    isErrorVisible,
    errorMessage,
    errorMessagesList,
    validate,
    showError,
    hideError,
  };
}
